import api from './api';

export const authService = {
  forgotPassword(email) {
    return api.post('/auth/forgot-password', { email });
  },
  verifyResetCode(email, code) {
    return api.post('/auth/verify-reset-code', { email, code });
  },
  resetPassword(email, code, newPassword) {
    return api.post('/auth/reset-password', { email, code, newPassword });
  },
};
